/* unplugin-vue-components disabled */import { render } from "./GHSubGroup.vue?vue&type=template&id=509df7e6&scoped=true"
import script from "./GHSubGroup.vue?vue&type=script&lang=js"
export * from "./GHSubGroup.vue?vue&type=script&lang=js"

import "./GHSubGroup.vue?vue&type=style&index=0&id=509df7e6&scoped=true&lang=css"
import "./GHSubGroup.vue?vue&type=style&index=1&id=509df7e6&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509df7e6"]])

export default __exports__